export interface FirstGeometryWaitState {
  sceneId: string | null;
  error: string | null;
  /** Meshes, lines and point clouds drawn so far. */
  renderedObjectsCount: number;
  /** True once a geometry request for the open scene has finished, with or without objects. */
  firstRefreshFinished: boolean;
}

/**
 * Whether the canvas is empty only because the first geometry has not arrived yet, so the page should say so.
 * A scene whose first request finished with nothing to draw is empty, not loading.
 */
export function isAwaitingFirstGeometry(state: FirstGeometryWaitState): boolean {
  return (
    state.sceneId !== null && state.error === null && state.renderedObjectsCount === 0 && !state.firstRefreshFinished
  );
}
